import { useEffect, useRef, useState } from "react";
import { useRegisterQuestionsStore } from "../store/useRegisterQuestionsStore";
import { useSearchProfileStore } from "../store/useSearchProfileStore";
import location_dark from '../assets/images/location_dark.png';
import birthday_dark from '../assets/images/birthday_dark.png';
import ruler_dark from '../assets/images/ruler_dark.png';
import notfound1 from '../assets/images/notfound1.png';
import add_img from '../assets/images/noimage.png';
import diamond_icon from '../assets/images/diamond_icon.png';
import { useSendLikeStore } from "../store/useSendLikeStore";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useMatchStore } from "../store/useMatchStore";
import Chat from "../components/Chat";
import { useNavigate } from "react-router-dom";
import useAuthStore from "../store/useAuthStore";
import { useUserStore } from "../store/useUserStore";
import { hasPremiumAccess } from '../utils/subscription'; 
import { useSubscriptionStore } from "../store/useSubscriptionStore";
import { getSizedImageUrl } from "../utils/getSizedImageUrl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const MySwal = withReactContent(Swal);


const Age: any = [];
for (let index = 18; index <= 99; index++) {
    Age.push(index);
}

const SearchProfile = () => {
  const { getRegisterQuestions, getQuestionByTitle } = useRegisterQuestionsStore();
  const { filters, setFilter, resetFilters, initFilters, fetchProfiles, profiles, loading, page, totalPages, setPage } = useSearchProfileStore();
  const [showMessaging, setShowMessaging] = useState(false);
  const [currentRecipient, setCurrentRecipient] = useState<{ id: number; name:string, city: string; state: string; distance: number, pic:string } | null>(null);
  
  const { loadinglike, sendLike, sendDiamond } = useSendLikeStore();
  
  const { user, getUserDetails } = useUserStore();
  const navigate = useNavigate();
  const authStore = useAuthStore.getState();
  const { paymentDetails, getSubscription } = useSubscriptionStore();
  const [resolvedImageMap, setResolvedImageMap] = useState<Record<string, string>>({});
  const [likedUsers, setLikedUsers] = useState<Set<number>>(new Set());
  const [diamondUsers, setDiamondUsers] = useState<Set<number>>(new Set());

  const filterRef = useRef<HTMLDivElement>(null);
  const actionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onScroll = () => {
      if (!filterRef.current || !actionRef.current) return;

      const filterRect = filterRef.current.getBoundingClientRect();
      const actionHeight = actionRef.current.offsetHeight;
      const viewportHeight = window.innerHeight;

      if (filterRect.bottom <= viewportHeight + actionHeight + 20) {
        actionRef.current.style.position = "static";
        actionRef.current.style.boxShadow = "none";
        actionRef.current.style.width = "100%";
      } else {
        const sidebarRect = filterRef.current.getBoundingClientRect();
        actionRef.current.style.position = "fixed";
        actionRef.current.style.bottom = "0px";
        actionRef.current.style.left = `${sidebarRect.left}px`;
        actionRef.current.style.width = `${sidebarRect.width}px`;
        actionRef.current.style.boxShadow = "0 10px 30px rgba(0,0,0,.15)";
      }
    };

    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    (async () => {
      const entries = await Promise.all(
        profiles.map(async (profile) => {
          const url = profile.picture;
          const sizedUrl = url ? await getSizedImageUrl(url, '150x150') : profile.pic;
          return [profile.id, sizedUrl];
        })
      );
      setResolvedImageMap(Object.fromEntries(entries));
    })();
  }, [profiles]);

  useEffect(() => {
    getSubscription(authStore.user?.id);
    getUserDetails(authStore.user?.id);
  }, [authStore.user?.id]);

  useEffect(() => {
    if (user?.lat && user?.lang) {
      setFilter("lat", user.lat);
      setFilter("lng", user.lang);
    }
  }, [user]);

  const { blockUser, reportUser } = useMatchStore();
  
  const handlePageChange = (newPage:any) => {
    if (newPage > 0 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  // ❤️ LIKE
  const handleSendLike = async (id: any) => {
    const ok = await sendLike(id, 50, "", "");
    if (ok) {
      toast.success("Liked Successfully! ❤️");
      setLikedUsers(prev => new Set(prev).add(id));
    } else {
      showUpgradePlanAlert();
    }
    setTimeout(() => { fetchProfiles(); }, 2000); 
  };

  // 💎 DIAMOND
  const handleSendDiamond = async (id: any) => {
    const ok = await sendDiamond(id);
    if (ok) {
      setDiamondUsers(prev => new Set(prev).add(id));
      setLikedUsers(prev => new Set(prev).add(id));
      toast(
        () => (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <img src={diamond_icon} alt="" style={{ width: '20px', height: '20px' }} />
            <span>Diamond Sent Successfully!</span>
          </div>
        ),
        {
          position: 'top-right',
          autoClose: 3000,
          style: { background: '#e8f4fd', color: '#1a6fa5', fontWeight: 500 },
        }
      );
    } else {
      MySwal.fire({
        html: (
          <div className="text-center">
            <img src={diamond_icon} alt="Diamond" style={{ width: '40px', marginBottom: '10px' }} />
            <h3>Limit Reached</h3>
            <p>You've used all your diamonds for today.</p>
            <div className="d-flex justify-content-center gap-2">
              <button className="btn btn-secondary" onClick={() => MySwal.close()}>Close</button>
              <button className="btn btn-primary" onClick={() => { MySwal.close(); navigate('/settings#subscription'); }}>Upgrade Now</button>
            </div>
          </div>
        ),
        showConfirmButton: false,
        showCloseButton: true,
        customClass: { popup: 'bg-light p-4 rounded', closeButton: 'btn-close position-absolute top-0 end-0 m-3' },
      });
    }
    setTimeout(() => { fetchProfiles(); }, 2000);
  };

  const confirmBlockUser = (userId:any, blockUser:any) => {
    MySwal.fire({
      html: (
        <div className="text-center">
          <h3>Block User?</h3>
          <p>Do you really want to block this user?</p>
          <div className="d-flex justify-content-center gap-2">
            <button className="btn btn-secondary" onClick={() => MySwal.close()}>Cancel</button>
            <button className="btn btn-danger" onClick={() => { blockUser(userId); fetchProfiles(); MySwal.close(); }}>Yes, Block</button>
          </div>
        </div>
      ),
      showConfirmButton: false,
      showCloseButton: true,
      customClass: { popup: 'bg-light p-4 rounded', closeButton: 'btn-close position-absolute top-0 end-0 m-3' },
    });
  };

  const confirmReportUser = (userId:any, reportUser:any) => {
    MySwal.fire({
      html: (
        <div className="text-center">
          <h3>Report User</h3>
          <p>Please enter the reason for reporting this user:</p>
          <textarea id="reportReason" className="form-control mb-3" placeholder="Enter your reason..." style={{ height: '100px', resize: 'none' }}></textarea>
          <div className="d-flex justify-content-center gap-2">
            <button className="btn btn-secondary" onClick={() => MySwal.close()}>Cancel</button>
            <button className="btn btn-danger" onClick={() => {
              const reasonInput = document.getElementById('reportReason') as HTMLTextAreaElement;
              if (!reasonInput || !reasonInput.value.trim()) { MySwal.showValidationMessage('Reason is required.'); return; }
              reportUser(userId, reasonInput.value.trim());
              MySwal.close();
              MySwal.fire('Reported!', 'The user has been reported successfully.', 'success');
            }}>Submit Report</button>
          </div>
        </div>
      ),
      showConfirmButton: false,
      showCloseButton: true,
      customClass: { popup: 'bg-light p-4 rounded', closeButton: 'btn-close position-absolute top-0 end-0 m-3' },
    });
  };

  useEffect(() => {
    getRegisterQuestions();
    initFilters();
    fetchProfiles();
    console.log('filter', filters);
  }, []);

  useEffect(() => {
    console.log('filter', filters);
  }, [filters]);

  // ── FIX: Height conversion — sabhi formats handle karta hai ──
  const convertHeightToCm = (height: any): string => {
    if (!height || typeof height !== 'string') return "Not set";

    const cleaned = height.trim()
      // smart quotes → straight
      .replace(/[\u2018\u2019]/g, "'")
      .replace(/[\u201C\u201D]/g, '"')
      // curly/unicode feet/inch symbols
      .replace(/′/g, "'")
      .replace(/″/g, '"');

    // Match formats:
    // 5'10"  5' 10"  5'10  5' 10  4'10"  4' 10"
    // Also handles missing inches part
    const match = cleaned.match(/^(\d+)\s*['''`]\s*(\d*)\s*["""″]?$/);

    if (!match) return "Not set";

    const feet = parseInt(match[1], 10);
    const inches = match[2] ? parseInt(match[2], 10) : 0;

    if (isNaN(feet) || isNaN(inches) || feet < 0 || inches < 0 || inches >= 12) return "Not set";

    const totalCm = feet * 30.48 + inches * 2.54;
    return `${totalCm.toFixed(0)} cm`;
  };

  const generateHeightOptions = () => {
    const options = [];
    for (let feet = 4; feet <= 7; feet++) {
      for (let inches = 0; inches < 12; inches++) {
        const height = `${feet}' ${inches}"`;
        options.push(<option key={height} value={height}>{height}</option>);
      }
    }
    return options;
  };

  const isPremium = hasPremiumAccess(paymentDetails);

  const showUpgradePlanAlert = () => {
    MySwal.fire({
      html: (
        <div className="text-center">
          <h3>Upgrade Plan</h3>
          <p>Upgrade your plan to send more messages.</p>
          <div className="d-flex justify-content-center gap-2">
            <button className="btn btn-secondary" onClick={() => MySwal.close()}>Close</button>
            <button className="btn btn-primary" onClick={() => { MySwal.close(); navigate('/settings#subscription'); }}>Upgrade Now</button>
          </div>
        </div>
      ),
      showConfirmButton: false,
      showCloseButton: true,
      customClass: { popup: 'bg-light p-4 rounded', closeButton: 'btn-close position-absolute top-0 end-0 m-3' },
    });
  };

  return (
    <section className="py-60 bg-light mymatches_searchs_section">
    <div className="container">
        <div className="row">
            <div className="col-lg-8 position-relative">
                <div className="section_title mb-4">
                    <h2 className="mb-4">Search Results</h2>
                </div>

                {loading ? (
                <p>Loading...</p>
              ) : profiles.length === 0 ? (
                <div className="mymatches_searchs_notfound">
                    <img src={notfound1} className="img-fluid" alt="" />
                    <h2>No matches found</h2>
                    <p>Modify or reset your search filters to expand your options.</p>
                </div>
              ) : (
              profiles.map((profile, index: number) => {
                const isBlurred = !isPremium && index >= 2;
                const heightCm = convertHeightToCm(profile.height);

                return (
                <div key={profile.id} className={`card mymatches_searchs_card_item ${isBlurred ? "blurred" : ""}`}>
                    <div className="mymatches_search_img_box">
                       <img src={resolvedImageMap[profile.id] || profile.pic || add_img} alt="" className="img-fluid" />
                    </div>
                    <div className="flex-grow-1 mymatches_searchs_card_info">
                        <h2>{profile.first_name}, {profile.age}</h2>
                        <ul>
                            <li><img src={location_dark} />{profile.city} {profile.state}, {profile.distance.toFixed(0)} miles away</li>
                            <li><img src={birthday_dark} />{profile.relationship}</li>
                            <li>
                              <img src={ruler_dark} />
                              {/* ── FIX: sirf height dikhao agar cm valid hai toh bracket mein ── */}
                              {profile.height}
                              {heightCm !== "Not set" ? ` (${heightCm})` : ""}
                            </li>
                        </ul>
                        <div className="mymatches_searchs_card_info_bottom">
                            <div className="dp_actions_btngroup mt-3">

                                {/* 💬 Message */}
                                <div className="dp_actions_btn_item">
                                    <button className="btn message_btn" onClick={() => {
                                      if (!isBlurred) {
                                        setShowMessaging(true);
                                        setCurrentRecipient({
                                          id: profile.id,
                                          name: `${profile.first_name}, ${profile.age}`,
                                          city: profile.city,
                                          state: profile.state,
                                          distance: profile.distance,
                                          pic: profile.picture || profile.pic
                                        });
                                      } else {
                                        showUpgradePlanAlert();
                                      }
                                    }}>
                                        <i className="fa-solid fa-paper-plane"></i>
                                    </button>
                                    Message
                                </div>

                                {/* ❤️ Like */}
                                <div className="dp_actions_btn_item">
                                    <button
                                      className="btn like_btn"
                                      onClick={() => isBlurred ? showUpgradePlanAlert() : handleSendLike(profile.id)}
                                      disabled={loadinglike || likedUsers.has(profile.id)}
                                      style={likedUsers.has(profile.id) ? { opacity: 0.7, cursor: 'not-allowed' } : {}}
                                    >
                                      <i className={`fa-heart ${likedUsers.has(profile.id) ? "fa-solid text-danger" : "fa-regular"}`}></i>
                                    </button>
                                    <span style={likedUsers.has(profile.id) ? { color: '#e74c3c', fontWeight: 600 } : {}}>
                                      {likedUsers.has(profile.id) ? "Liked" : "Like"}
                                    </span>
                                </div>

                                {/* 💎 Diamond */}
                                <div className="dp_actions_btn_item">
                                    <button
                                      className="btn diamond_btn"
                                      onClick={() => isBlurred ? showUpgradePlanAlert() : handleSendDiamond(profile.id)}
                                      disabled={loadinglike || diamondUsers.has(profile.id)}
                                      style={{
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        backgroundColor: '#ffffff', border: '1px solid #e0e0e0', borderRadius: '50%',
                                        ...(diamondUsers.has(profile.id) ? { opacity: 0.7, cursor: 'not-allowed' } : {}),
                                      }}
                                    >
                                      <img
                                        src={diamond_icon}
                                        alt="Diamond"
                                        style={{
                                          width: '22px', height: '22px', objectFit: 'contain',
                                          transition: 'transform 0.2s ease',
                                          ...(diamondUsers.has(profile.id) ? { filter: 'brightness(0.8)' } : {}),
                                        }}
                                        onMouseOver={(e) => { if (!diamondUsers.has(profile.id)) e.currentTarget.style.transform = 'scale(1.15)'; }}
                                        onMouseOut={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
                                      />
                                    </button>
                                    <span style={diamondUsers.has(profile.id) ? { color: '#1a6fa5', fontWeight: 600 } : {}}>
                                      {diamondUsers.has(profile.id) ? "Sent" : "Diamond"}
                                    </span>
                                </div>

                            </div>
                            <button className="btn btn-outline-primary py-2" onClick={() => isBlurred ? showUpgradePlanAlert() : navigate(`/profile/${profile.id}`)}>View profile</button>
                        </div>
                        <div className="dp_info_drpdwn_wrpr">
                            <button className="btn btn-sm dropdown-toggle dp_info_drpdwn" type="button"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                <i className="fa-solid fa-ellipsis-vertical"></i>
                            </button>
                            <ul className="dropdown-menu">
                                <li><a className="dropdown-item" href="#" onClick={() => isBlurred ? undefined : confirmBlockUser(profile.id, blockUser)}>Block User</a></li>
                                <li><a className="dropdown-item" href="#" onClick={() => isBlurred ? undefined : confirmReportUser(profile.id, reportUser)}>Report</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                );
              })
              )}

                {profiles.length > 0 && isPremium ? 
                <nav className="custom_pagination_wrapper justify-content-end mt-5">
                    <ul className="pagination">
                        <li className="page-item">
                            <a className="page-link" href="#" onClick={() => handlePageChange(page - 1)} aria-label="Previous">
                                <i className="fa-solid fa-chevron-left"></i>
                            </a>
                        </li>
                        {[...Array(totalPages)].map((_, index) => (
                        <li className={`page-item ${page === index + 1 ? "active" : ""}`} key={index}>
                          <a href="#" className="page-link" onClick={() => handlePageChange(index + 1)}>{index + 1}</a>
                        </li>
                      ))}
                        <li className="page-item">
                            <a className="page-link" href="#" aria-label="Next" onClick={() => handlePageChange(page + 1)}>
                                <i className="fa-solid fa-chevron-right"></i>
                            </a>
                        </li>
                    </ul>
                </nav>:''}

            </div>
            <div className="col-lg-4 position-relative">
                <div className="card border filter-container" ref={filterRef}>
                    <div className="accordion" id="accordionPanelsStayOpenExample">
                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true"
                                    aria-controls="panelsStayOpen-collapseOne">
                                    Relationship Preferences
                                </button>
                            </h2>
                            <div id="panelsStayOpen-collapseOne" className="accordion-collapse collapse show">
                                <div className="accordion-body">
                                    <div className="filter-section">
                                        <h5 className="filter-title">Gender</h5>
                                        <div className="filter-options">
                                        {getQuestionByTitle("Gender")?.questions_options.map((option) => (
                                          <div key={option.id} className="form-check">
                                            <input className="form-check-input" type="checkbox" name="gender" id={option.option} 
                                            checked={filters.gender.map(Number).includes(option.id)}
                                            onChange={() =>
                                                setFilter("gender", filters.gender.includes(option.id)
                                                  ? filters.gender.filter((g) => g !== option.id)
                                                  : [...filters.gender, option.id])
                                              } />
                                            <label className="form-check-label" htmlFor={option.option}>{option.option}</label>
                                          </div>
                                        ))}
                                        </div>
                                    </div>

                                    <div className="filter-section">
                                        <h5 className="filter-title">Relationship Intent</h5>
                                        <div className="filter-options">
                                        {getQuestionByTitle("Looking_Relationship")?.questions_options.map((option) => (
                                            <div key={option.id} className="form-check">
                                              <input className="form-check-input" type="checkbox" name="relationship" id={`option-${option.id}`}
                                              checked={filters.relationshipIntent.map(Number).includes(option.id)} 
                                              onChange={() =>
                                                  setFilter("relationshipIntent", filters.relationshipIntent.includes(option.id)
                                                    ? filters.relationshipIntent.filter((r) => r !== option.id)
                                                    : [...filters.relationshipIntent, option.id])
                                                } />
                                              <label className="form-check-label" htmlFor={`option-${option.id}`}>{option.option}</label>
                                            </div>
                                          ))}
                                        </div>
                                    </div>
                                    <div className="filter-section">
                                        <h5 className="filter-title">Age Range</h5>
                                        <div className="d-flex align-items-center">
                                            <select className="form-select me-2 flex-grow-1" style={{width: '80px;'}} value={String(filters.minAge)} onChange={(e) => setFilter("minAge", parseInt(e.target.value))}>
                                                <option value="">Min</option>
                                                {Age.map((val: any) => (<option key={val} value={val}>{val}</option>))}
                                            </select>
                                            <span>To</span>
                                            <select className="form-select mx-2 flex-grow-1" style={{width: '80px;'}} value={String(filters.maxAge)} onChange={(e) => setFilter("maxAge", parseInt(e.target.value))}>
                                                <option value="">Max</option>
                                                {Age.map((val: any) => (<option key={val} value={val}>{val}</option>))}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="filter-section">
                                        <h5 className="filter-title d-flex align-items-center">Location <span className="ms-auto font12">{filters.location} miles</span></h5>
                                        <input type="range" className="form-range age-range-slider" min="0" max="200"
                                            value={filters.location} onChange={(e) => setFilter("location", parseInt(e.target.value))} />
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button"
                                        data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo"
                                        aria-expanded="true" aria-controls="panelsStayOpen-collapseTwo">
                                        Background
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseTwo" className="accordion-collapse collapse show">
                                    <div className="accordion-body">
                                        <div className="filter-section">
                                            <h5 className="filter-title">Ethnicity</h5>
                                            <select className="form-select" value={filters.ethnicity} onChange={(e) => setFilter('ethnicity', e.target.value)}>
                                                <option value=''>Anything</option>
                                              {getQuestionByTitle("Ethnicity")?.questions_options.map((option) => (
                                                <option value={option.id}>{option.option}</option>
                                              ))}
                                            </select>
                                        </div>
                                        <div className="filter-section">
                                            <h5 className="filter-title">Education</h5>
                                            <select className="form-select" value={filters.education} onChange={(e) => setFilter('education', e.target.value)}>
                                              <option value=''>Anything</option>
                                              {getQuestionByTitle("Education")?.questions_options.map((option) => (
                                                <option value={option.id}>{option.option}</option>
                                              ))}
                                            </select>
                                        </div>
                                        <div className="filter-section">
                                            <h5 className="filter-title">Religion/Faith</h5>
                                            <select className="form-select" value={filters.religion} onChange={(e) => setFilter('religion', e.target.value)}>
                                              <option value=''>Anything</option>
                                            {getQuestionByTitle("Religion")?.questions_options.map((option) => (
                                              <option value={option.id}>{option.option}</option>
                                            ))}
                                            </select>
                                        </div>
                                        <div className="filter-section">
                                            <h5 className="filter-title">Marital status</h5>
                                            {getQuestionByTitle("Relationship_status")?.questions_options.map((option) => (
                                              <div key={option.id} className="form-check">
                                                <input className="form-check-input" type="checkbox" name="marital" id={`option-${option.id}`} 
                                                checked={filters.maritalStatus.includes(option.id)} 
                                                onChange={() =>
                                                    setFilter("maritalStatus", filters.maritalStatus.includes(option.id)
                                                      ? filters.maritalStatus.filter((r) => r !== option.id)
                                                      : [...filters.maritalStatus, option.id])
                                                  } />
                                                <label className="form-check-label" htmlFor={`option-${option.id}`}>{option.option}</label>
                                              </div>
                                            ))}
                                        </div>
                                        <div className="filter-section">
                                            <h5 className="filter-title">Political affiliation</h5>
                                            {getQuestionByTitle("Politics")?.questions_options.map((option) => (
                                                <div key={option.id} className="form-check">
                                                  <input className="form-check-input" type="checkbox" name="political" id={`option-${option.id}`} 
                                                  checked={filters.politicalAffiliation.includes(option.id)} 
                                                  onChange={() =>
                                                      setFilter("politicalAffiliation", filters.politicalAffiliation.includes(option.id)
                                                        ? filters.politicalAffiliation.filter((r) => r !== option.id)
                                                        : [...filters.politicalAffiliation, option.id])
                                                    } />
                                                  <label className="form-check-label" htmlFor={`option-${option.id}`}>{option.option}</label>
                                                </div>
                                              ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button"
                                        data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree"
                                        aria-expanded="true" aria-controls="panelsStayOpen-collapseThree">
                                        Looks
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseThree" className="accordion-collapse collapse show">
                                    <div className="accordion-body">
                                        <div className="filter-section">
                                            <h5 className="filter-title">Minimum height</h5>
                                            <select className="form-select" value={String(filters.minHeight)} onChange={(e) => setFilter("minHeight", e.target.value)}>
                                                <option value=''>Anything</option>
                                                {generateHeightOptions()}
                                            </select>
                                        </div>
                                        <div className="filter-section">
                                            <h5 className="filter-title">Max height</h5>
                                            <select className="form-select" value={String(filters.maxHeight)} onChange={(e) => setFilter("maxHeight", e.target.value)}>
                                                <option value=''>Anything</option>
                                                {generateHeightOptions()}
                                            </select>
                                        </div>
                                        <div className="filter-section">
                                            <h5 className="filter-title">Body Type</h5>
                                            {getQuestionByTitle("Body_type")?.questions_options.map((option) => (
                                                <div key={option.id} className="form-check">
                                                  <input className="form-check-input" type="checkbox" name="political" id={`option-${option.id}`} 
                                                  checked={filters.bodyType.includes(option.id)} 
                                                  onChange={() =>
                                                      setFilter("bodyType", filters.bodyType.includes(option.id)
                                                        ? filters.bodyType.filter((r) => r !== option.id)
                                                        : [...filters.bodyType, option.id])
                                                    } />
                                                  <label className="form-check-label" htmlFor={`option-${option.id}`}>{option.option}</label>
                                                </div>
                                              ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button"
                                        data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFour"
                                        aria-expanded="true" aria-controls="panelsStayOpen-collapseFour">
                                        Lifestyle
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseFour" className="accordion-collapse collapse show">
                                    <div className="accordion-body">
                                        <div className="filter-section">
                                            <h5 className="filter-title">Smoker?</h5>
                                            {getQuestionByTitle("Smokes")?.questions_options.map((option) => (
                                                <div key={option.id} className="form-check">
                                                  <input className="form-check-input" type="checkbox" name="smoker" id={`option-${option.id}`} 
                                                  checked={filters.smoker.includes(option.id)} 
                                                  onChange={() =>
                                                      setFilter("smoker", filters.smoker.includes(option.id)
                                                        ? filters.smoker.filter((r) => r !== option.id)
                                                        : [...filters.smoker, option.id])
                                                    } />
                                                  <label className="form-check-label" htmlFor={`option-${option.id}`}>{option.option}</label>
                                                </div>
                                              ))}
                                        </div>
                                        <div className="filter-section">
                                            <h5 className="filter-title">Alcohol</h5>
                                            {getQuestionByTitle("Drinks")?.questions_options.map((option) => (
                                                <div key={option.id} className="form-check">
                                                  <input className="form-check-input" type="checkbox" name="alcohol" id={`option-${option.id}`} 
                                                  checked={filters.alcohol.includes(option.id)} 
                                                  onChange={() =>
                                                      setFilter("alcohol", filters.alcohol.includes(option.id)
                                                        ? filters.alcohol.filter((r) => r !== option.id)
                                                        : [...filters.alcohol, option.id])
                                                    } />
                                                  <label className="form-check-label" htmlFor={`option-${option.id}`}>{option.option}</label>
                                                </div>
                                              ))}
                                        </div>
                                        <div className="filter-section">
                                            <h5 className="filter-title">Marijuana friendly</h5>
                                            {getQuestionByTitle("420_firendly")?.questions_options.map((option) => (
                                                <div key={option.id} className="form-check">
                                                  <input className="form-check-input" type="checkbox" name="marijuanaFriendly" id={`option-${option.id}`} 
                                                  checked={filters.marijuanaFriendly.includes(option.id)} 
                                                  onChange={() =>
                                                      setFilter("marijuanaFriendly", filters.marijuanaFriendly.includes(option.id)
                                                        ? filters.marijuanaFriendly.filter((r) => r !== option.id)
                                                        : [...filters.marijuanaFriendly, option.id])
                                                    } />
                                                  <label className="form-check-label" htmlFor={`option-${option.id}`}>{option.option}</label>
                                                </div>
                                              ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div ref={actionRef} className="filter-actions">
                      <button className="btn btn-outline-secondary py-2" onClick={resetFilters}>Reset</button>
                      <button className="btn btn-primary py-2" onClick={() => { setPage(1); fetchProfiles(); }}>Apply Filters</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {showMessaging && currentRecipient && (
      <Chat 
        toUser={currentRecipient.id}
        name={currentRecipient.name}
        city={currentRecipient.city}
        state={currentRecipient.state}
        distance={currentRecipient.distance}
        pic={currentRecipient.pic}
        show={showMessaging} 
        handleClose={() => setShowMessaging(false)} 
      />
    )}
</section>
  );
};

export default SearchProfile;